import {useEffect, useState} from 'react';

import useSaveViewBeforeLeavingReport from '../../../../hooks/components/onboarding/useSaveOnboardingVideoProgressionBeforePageLeave';
import useProfile from '../../../../hooks/providers/useProfile';

const OnboardingSingleFlowVideo = () => {
  const [isLoading, setIsLoading] = useState(true);

  const {videoRef, currentFlowStep, setCurrentFlowStepPosition, setCurrentVideoDuration, goToNextVideo} = useProfile();

  useSaveViewBeforeLeavingReport();

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (video && video.duration > 0) {
      const progress = Math.round((video.currentTime / video.duration) * 100);
      setCurrentFlowStepPosition(currentFlowStep.step_id, progress);
    }
  };

  useEffect(() => {
    setIsLoading(true);
  }, [currentFlowStep]);

  // This hook aims to reset video to beginning if it has already been fully seen
  useEffect(() => {
    if (currentFlowStep.position === 100) {
      setCurrentFlowStepPosition(currentFlowStep.step_id, 0);
    }
  }, [currentFlowStep]);

  useEffect(() => {
    const video = videoRef?.current;
    if (!currentFlowStep.url_video || isLoading || !video) return;

    setCurrentVideoDuration(video.duration);

    if (currentFlowStep.position > 0) {
      const newTime = (currentFlowStep.position / 100) * (video.duration || 0);
      video.currentTime = newTime;
    }
  }, [isLoading, currentFlowStep.url_video]);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        autoPlay={currentFlowStep.position !== 100}
        muted
        data-testid="video-fallback"
        ref={videoRef}
        onLoadedMetadata={() => {
          setIsLoading(false);
        }}
        onEnded={() => {
          goToNextVideo();
        }}
        onTimeUpdate={handleTimeUpdate}
        controls
        style={{
          width: 'auto',
          maxWidth: '100%',
          height: '100%',
          maxHeight: 350,
          margin: '0 auto',
          display: 'block',
          borderRadius: 2,
          objectFit: 'contain'
        }}
        src={currentFlowStep.url_video}
      />
    </>
  );
};

export default OnboardingSingleFlowVideo;
